import * as React from "react";

function SvgPlus(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 10.001 10.001" {...props}>
      <path
        fill="currentColor"
        d="M4 9V6H1a1 1 0 01-1-1 1 1 0 011-1h3V1a1 1 0 011-1 1 1 0 011 1v3h3a1 1 0 011 1 1 1 0 01-1 1H6v3a1 1 0 01-1 1 1 1 0 01-1-1z"
        data-name="Uni\xE3o 13"
      />
    </svg>
  );
}

export default SvgPlus;

